import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetHelpCenterArticle} from '../hooks/useGetHelpCenterArticle';
import {HelpCenterArticleView} from './HelpCenterArticleView';
import {LoadingPlaceholder} from './LoadingPlaceholder';

export const HelpCenterArticle = ({
  isTitleFloating,
}: {
  isTitleFloating?: boolean;
}) => {
  return (
    <DataFetcher
      request={useGetHelpCenterArticle()}
      View={HelpCenterArticleView}
      viewProps={{isTitleFloating}}
      Error={() => null}
      Loading={LoadingPlaceholder}
    />
  );
};
